(() => {
  'use strict';
  const intro = document.querySelector('[data-zd-intro]');
  if (intro) {
    const video = intro.querySelector('video');
    let seen = true;
    try { seen = sessionStorage.getItem('zd-intro-v1') === 'seen'; } catch (_) {}
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const connection = navigator.connection;
    const slow = connection && (connection.saveData || /2g/.test(connection.effectiveType));
    if (!seen && !reduced && !slow && typeof intro.showModal === 'function') {
      try { sessionStorage.setItem('zd-intro-v1', 'seen'); } catch (_) {}
      const previousFocus = document.activeElement;
      let closed = false;
      const close = () => {
        if (closed) return;
        closed = true;
        video.pause();
        intro.close();
        if (previousFocus && previousFocus !== document.body) previousFocus.focus();
      };
      intro.style.cursor = 'pointer';
      intro.addEventListener('click', close);
      intro.addEventListener('cancel', close);
      video.addEventListener('error', close);
      video.addEventListener('ended', close);
      video.addEventListener('timeupdate', () => { if (video.currentTime >= 2.5) close(); });
      intro.showModal();
      const deadline = setTimeout(close, 3000);
      intro.addEventListener('close', () => { clearTimeout(deadline); video.pause(); });
      video.src = video.dataset.src;
      video.play().catch(close);
      setTimeout(() => { if (video.readyState < 2) close(); }, 650);
    }
  }
  const init = (root) => {
    root.querySelectorAll('[data-zd-buy-bar]').forEach(bar => {
      if (bar.dataset.ready || !('IntersectionObserver' in window)) return;
      bar.dataset.ready = 'true';
      const section = bar.closest('.shopify-section');
      const form = section && section.querySelector('product-form');
      const target = section && section.querySelector('.product__info-container');
      if (!form || !target) return;
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, {threshold: 0});
      observer.observe(form);
      bar.querySelector('a').addEventListener('click', () => {
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === section) observer.disconnect();
      }, {once: true});
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
